<template>
  <div class="cart-summary critical-component-clear">
    <div
      v-if="totalDiscounts > 0"
      class="cart-summary__total cart-summary__total--discount"
    >
      <p
        class="cart-summary__total-label--discount text-body-l-regular"
        v-text="$string('cart.summary.discount_label')"
      />
      <product-prices
        :class-price="discountPriceClass"
        element="p"
        prefix="-"
        :price="totalDiscounts"
      />
    </div>
    <div class="cart-summary__total">
      <p
        class="cart-summary__total-label"
        :class="{ 'text-body-l-regular': !small,
                  'text-body-l-regular text-body-xl-regular-desktop': small }"
        v-text="$string('cart.summary.subtotal_label')"
      />

      <product-prices
        :class-price="priceClass"
        element="p"
        :price="cart.total_price"
      />
    </div>

    <div
      v-if="!empty"
      class="cart-summary__cta"
    >
      <form
        class="cart-drawer__checkout"
        :action="$variable('routes.cart.url')"
        method="post"
      >
        <p
          v-if="!sticky && subtitle"
          class="cart-summary__subtitle text-body-s-regular mt-m"
          v-text="subtitle"
        />

        <btn
          class="cart-summary__submit"
          :label="$string('cart.checkout')"
          modifiers="primary block center fill"
          name="checkout"
          :show-icon="false"
          type="submit"
        />
      </form>

      <ul
        v-if="!sticky && uspBlocks.length > 0"
        class="cart-summary__usp mt-xl"
      >
        <template
          v-for="(block, index) of uspBlocks"
          :key="index"
        >
          <li
            v-if="block.text"
            class="text-body-m-regular cart-summary__usp-item"
          >
            <div class="cart-summary__usp-icon">
              <responsive-image
                v-if="block.icon.src"

                :image="{
                  src: block.icon.src
                }"
                ratio="1:1"
              />
            </div>

            <span
              v-if="block.text"
              class="text-body-l-regular"
              v-text="block.text"
            />
          </li>
        </template>
      </ul>
      <a
        v-if="!isCartTemplate"
        :href="$variable('routes.cart.url')"
        class="cart-summary__view-cart text-link"
        v-text="$string('cart.view_cart')"
      />
    </div>
    <div
      v-else
    >
      <btn
        class="cart-summary__submit"
        :label="$string('cart.continue_shopping')"
        modifiers="primary block center fill"
        name="checkout"
        :show-icon="false"
        type="submit"
        @click.prevent="closeOverlay(namespace)"
      />
    </div>
  </div>
</template>

<script>

/**
 * Vue: Cart summary (cart-summary)
 * -----------------------------------------------------------------------------
 * Summary of cart metrics with checkout CTA.
 *
 * @param {Boolean} [small] - Use mobile layout at all breakpoints.
 *
 */
import { mapActions, mapState } from 'vuex'
import ResponsiveImage from '~global/images/responsive-image'
import Btn from '~global/btn/btn'
import ProductPrices from '~global/product-prices/product-prices'

export default {
  name: 'CartSummary',

  components: {
    Btn,
    ResponsiveImage,
    ProductPrices,
  },

  props: {
    small: {
      type: Boolean,
      default: false,
    },
    empty: {
      type: Boolean,
      default: false,
    },
    subtitle: {
      type: String,
      default: '',
    },
    uspBlocks: {
      type: Array,
      default: () => [],
    },
    sticky: {
      type: Boolean,
      default: false,
    },
  },

  computed: {

    /**
     * Map Vuex state.
     */
    ...mapState({
      cart: (state) => state.cart.response,
      isMobile: (state) => state.index.screen.mobile,
    }),

    /**
     * Compute total discounts.
     * - Includes both compare at price savings and script discounts.
     * @returns {Number}
     */
    totalDiscounts() {
      let savings = 0
      let discounts = 0

      this.cart.items.forEach((lineItem) => {
        if (lineItem.compare_at_line_price) {
          const difference = lineItem.compare_at_line_price - lineItem.final_line_price

          if (difference <= 0) {
            return
          }

          savings += difference
        }

        discounts += lineItem.line_level_total_discount
      })

      return savings + discounts
    },

    isCartTemplate() {
      return cnvs.template.name === 'cart'
    },

    priceClass() {
      return 'text-heading-l'
    },

    discountPriceClass() {
      return 'text-heading-m'
    },
  },

  methods: {

    /**
     * Map Vuex actions.
     */
    ...mapActions({
      closeOverlay: 'overlays/close',
    }),

    /**
     * Shopify section editor select event.
     */
    shopifySectionSelect() {
      this.overlay.open({
        component: 'cart-drawer',
        namespace: 'cartDrawer',
        ignoreDismissed: true,
      })
    },
  },
}
</script>

<style lang="scss">
@import './cart-summary';
</style>
